import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import { isMABCExcludedItem } from "../../util/isReturnAndMABCExcludedItem.mjs";
import "bezier-easing";
import { logger } from "../../util/logger.mjs";
import "js-cookie";
const buyBoxGetters = {
  /* props used in BuyBox */
  buyBoxProps(state, getters) {
    return {
      buyBoxAlertMessage: getters.computedBuyBoxAlertMessage,
      price: getters.computedPrice,
      displayPrice: getters.displayPrice,
      flairBadge: getters.computedFlairBadge,
      isMember: getters.unifiedCustomerData.isMember,
      offerType: getters.computedPrice.offerType,
      priceInfo: getters.priceInfo,
      pupInfo: state.product.displayOptions.pupInfo || {},
      purchaseFormProps: getters.purchaseFormProps,
      enableBuyBoxAlertMessage: getters.enableBuyBoxAlertMessage,
      description: state.product.description,
      estimatedRewardsText: getters.estimatedRewardsText,
      showEstimatedRewards: getters.showEstimatedRewards
    };
  },
  /*---------------------------------------------
    prop data for nested complex components
  ---------------------------------------------*/
  purchaseFormProps(state, getters) {
    return {
      addToCartButtonProps: getters.computedAddToCartButtonProps,
      colorSelectorProps: getters.colorSelectorProps,
      errors: state.buyBoxValidation,
      favoriteButtonProps: getters.favoriteButtonProps,
      freeShipping: state.messages.freeShipping,
      fulfillmentTileProps: getters.fulfillmentTileProps,
      isLowInventory: getters.isLowInventorySku,
      klarnaPrice: getters.klarnaPrice,
      membershipMessaging: getters.membershipMessaging,
      notifyMeProps: getters.notifyMeProps,
      quantity: state.quantity,
      shipUrgency: state.messages.shipUrgency,
      showShipUrgencyLink: getters.appPropsMap.triageToggles.shipUrgencyLink,
      showNotifyMe: getters.showNotifyMe,
      sizeChart: getters.sizeChartData,
      sizeSelectorProps: getters.sizeSelectorProps,
      shopperInsightsProps: getters.productInsights,
      skuSelectorProps: getters.computedSkuProps,
      showCobrand: getters.showCobrand,
      showCobrandDoubleRewards: getters.showDoubleRewards,
      showKlarnaV1: getters.showKlarnaBelowATC,
      showKlarnaV2: getters.showKlarnaAboveATC,
      cobrandMessage: getters.cobrandMessage,
      pickupContextMessage: getters.pickupContextMessage,
      contextualizedEarnMessage: getters.contextualizedEarnMessage,
      // MEM-2155, MEM-2291
      selectedPriceClearanceMessage: getters.selectedPriceClearanceMessage
    };
  },
  /**
     * getters.sizeSelectorProps
     * @param {String} state.product.displayOptions.sizeLabel Label for the 'size' field.
     * Size, Flavor, etc
     * @param {String} state.tempSize name for a size that is currently focused, but not selected
     * @param {Array} state.product.sizes list of all sizes for a style
     * @param {String} getters.computedSelectedSize derived name of selected size
     * @param {Number} getters.appPropsMap.textStrings.maxSizeButtons the number of sizes that
     *   determine whether to show buttons or dropdown for size
     * @returns {Object} props required for the display of the Size Selector component
     */
  sizeSelectorProps(state, getters) {
    var _a, _b, _c;
    const {
      sizeLabel
    } = state.product.displayOptions;
    const selectedPrice = getters.computedSelectedPriceValue;
    const enableSoldOutSizes = (_a = getters.appPropsMap.launchToggles) == null ? void 0 : _a.enableSoldOutSizes;
    const showMixedPrice = state.product.mixedPriceOptions.isPriceBySize || state.product.mixedPriceOptions.isPriceBySizeAndColor;
    const showDropdown = !showMixedPrice && state.product.sizes.length > getters.appPropsMap.textStrings.maxSizeButtons;
    const dropdownSizes = showDropdown ? {
      // TODO: Cleanup PDX-5792
      available: enableSoldOutSizes ? state.product.sizesV2 : getters.computedDropdownAvailableSizes,
      unavailable: getters.computedDropdownUnavailableSizes,
      unavailableForAll: getters.computedDropdownUnavailableForAllSizes
    } : {};
    return {
      dropdownSizes,
      selectedPrice,
      selectedSize: getters.computedSelectedSize,
      hoverSize: state.tempSize,
      selectedSizeIsAvailable: getters.selectedSizeIsAvailable,
      showDropdown,
      showMixedPrice,
      showSizes: state.product.sizes.filter((size) => size !== "NONE").length > 0,
      sizeLabelName: sizeLabel,
      skusForSize: state.product.skusForOption.sizes,
      groupedSizes: getters.sizeDisplayGroups,
      // TODO: Cleanup PDX-5792
      enableSoldOutSizes: (_c = (_b = getters.appPropsMap) == null ? void 0 : _b.launchToggles) == null ? void 0 : _c.enableSoldOutSizes
    };
  },
  /**
   * props for color selector component
   *
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  colorSelectorProps(state, getters) {
    const groupedColors = getters.colorDisplayGroups;
    const selectedPrice = getters.computedSelectedPriceValue;
    const {
      styleId
    } = state.product;
    const skusForColor = state.product.skusForOption.colors;
    const showColors = !state.product.displayOptions.showSkuDropDown && getters.availableColors.filter(({
      name
    }) => name.toLowerCase() !== "none").length > 0;
    return {
      groupedColors,
      showGroups: groupedColors.length > 1 && state.product.mixedPriceOptions.isPriceByColor,
      selectedColor: getters.computedSelectedColor,
      selectedColorIsAvailable: getters.selectedColorIsAvailable,
      selectedPrice,
      showColors,
      styleId,
      skusForColor,
      tileSize: getters.appPropsMap.textStrings.swatchSize,
      label: getters.colorLabel
    };
  },
  /**
   * getters.computedSkuProps
   * @param {String} state.product.displayOptions.sizeLabel Label for the 'size' field.
   * Size, Flavor, etc
   * @param {String} state.product.displayOptions.colorLabel Label for the 'color' field'.
   * Color, Frame, etc
   * @param {Boolean} state.product.displayOptions.showSkuDropDown (note casing).
   * Flag from controller for showing the combined size/color/price dropdown
   * @param {Array} getters.skuDropdownLabels Computed list of skuIDs and HTML for
   * sku dropdown options
   * @param {Object} getters.computedSelectedSku Sku object that is currently selected by app
   * @returns {Object} Props object for the display of the Sku Selector component
   */
  computedSkuProps(state, getters) {
    const {
      sizeLabel,
      colorLabel,
      showSkuDropDown
    } = state.product.displayOptions;
    const {
      sizes,
      colors
    } = state.product;
    const onlyHasNoneColor = colors.length === 1 && colors[0].name.toLowerCase() === "none";
    const onlyHasNoneSize = state.product.sizes.length === 1 && sizes[0].toLowerCase() === "none";
    const showSkuDropdown = showSkuDropDown && (!onlyHasNoneColor || !onlyHasNoneSize);
    return {
      availableSkus: getters.skuDropdownLabels,
      label: `${colorLabel}/${sizeLabel}`,
      selectedSku: getters.computedSelectedSku,
      showSkuDropdown
    };
  },
  /**
  *
  * getters.product.sitkaData
  * @param {*} state.sitkaData product insights
  * @returns {Object} Object with Sitka data
  */
  productInsights(state) {
    return state.sitkaData.amount && state.sitkaData.actionType ? state.sitkaData : null;
  },
  /**
   * getters.oversizeMessage
   *
   * @params from state.product
   * @param {Boolean} anyOversizeCharges whether any skus have oversize charges
   * @param {Boolean} hideOversizeMessaging whether oversize messaging should be hidden
   *   for this style (set by BRT)
   * @params from getters
   * @param {Boolean} isSkuSelected true if a sku is currently selected
   * @param {Boolean} computedSelectedSku.oversize true if the selected sku has oversize charges
   * @param {Number} computedSelectedSku.oversizeCharge the $amount of the oversize charge
   * @returns {String} message that shows instead of free shipping for oversize items
   */
  oversizeMessage(state, getters) {
    const {
      anyOversizeCharges,
      hideOversizeMessaging
    } = state.product;
    if (!anyOversizeCharges || hideOversizeMessaging) return "";
    const {
      isSkuSelected
    } = getters;
    if (!isSkuSelected) return "Oversize shipping may apply";
    const {
      oversize,
      oversizeCharge
    } = getters.computedSelectedSku;
    if (oversize === false) return "";
    if (oversizeCharge) return `$${oversizeCharge} oversize shipping applies`;
    return "";
  },
  /**
   * getters.hasAnyShippingRestrictions
   *
   * @params from state
   * @param {Boolean} product.anySkuShippingRestrictions: does this style have any sku level
   *   shipping restrictions at all
   * @param {Array<Object>} messages.shippingRestrictions: list of shipping restrictions,
   *  if none, returns null
   * @returns {Boolean} true if the style has any style or sku shipping restrictions
   */
  hasAnyShippingRestrictions(state) {
    const {
      anySkuShippingRestrictions
    } = state.product;
    const {
      shippingRestrictions
    } = state.messages;
    return !!shippingRestrictions || anySkuShippingRestrictions;
  },
  /**
   * getters.computedShippingRestrictions
   *  _._     _,-'""`-._
   * (,-.`._,'(       |\`-/|
   *     `-.-' \ )-`( , o o)
   *           `-    \`_`"'-
   *
   * @params from state:
   * @param {Array} messages.shippingRestrictions: list of shipping restrictions,
   *  if none, returns null. Actual message is nested { message: 'message text'}
   * @param {Boolean} product.anySkuShippingRestrictions: does this style have any sku level
   *   shipping restrictions at all
   * @params from getters:
   * @param {Boolean} hasAnyShippingRestrictions: true if any style/sku shipping restrictions
   * @param {Boolean} isSkuSelected: true if a sku is currently selected
   * @param {Boolean} computedSelectedSku.anyShippingRestrictions: true if the selected sku
   *   has any sku-level shipping restrictions
   * @param {Object<String>} computedSelectedSku.shippingRestrictions: keyed list of sku-level
   *   shipping restrictions, handled differently depending on the restriction
   * @returns {Array<Object>} a list of { message: 'message text'} restrictions to be displayed
   */
  computedShippingRestrictions(state, getters) {
    const defaultMessage = [{
      message: "Some size and color combinations may have shipping restrictions. Please choose a size and color to view restrictions."
    }];
    const {
      hasAnyShippingRestrictions,
      isSkuSelected,
      computedSelectedSku
    } = getters;
    if (!hasAnyShippingRestrictions) return null;
    const styleRestrictions = state.messages.shippingRestrictions || [];
    const defaultNeeded = !isSkuSelected && state.product.anySkuShippingRestrictions;
    const getSkuRestrictions = () => {
      const {
        anyShippingRestrictions,
        shippingRestrictions
      } = computedSelectedSku;
      if (anyShippingRestrictions) {
        return Object.keys(shippingRestrictions).filter((key) => key !== "storePickupRestriction" && shippingRestrictions[key]).map((key) => ({
          message: shippingRestrictions[key]
        }));
      }
      return [];
    };
    const restrictions = [...styleRestrictions, ...defaultNeeded ? defaultMessage : [], ...isSkuSelected ? getSkuRestrictions() : []];
    return restrictions.length > 0 ? restrictions : null;
  },
  /**
   * getters.shippingRestrictionSummaryMessage
   *
   * @param {Array} state.messages.shippingRestrictions: list of shipping restrictions,
   *  if none, returns null.
   * @params from getters
   * @param {Boolean} hasAnyShippingRestrictions: true if any style/sku shipping restrictions
   * @param {Boolean} isSkuSelected: true if a sku is currently selected
   * @param {Boolean} computedSelectedSku.anyShippingRestrictions: true if the selected sku
   *   has any sku-level shipping restrictions
   * @param {Object<String>} computedSelectedSku.shippingRestrictions: keyed list of sku-level
   *   shipping restrictions, handled differently depending on the restriction
   * @returns {String} summary message around whether shipping restrictions apply
   */
  shippingRestrictionSummaryMessage(state, getters) {
    if (!getters.hasAnyShippingRestrictions) return "";
    if (state.messages.shippingRestrictions) return "Shipping restrictions apply";
    if (!getters.isSkuSelected) return "Shipping restrictions may apply";
    if (getters.computedSelectedSku.anyShippingRestrictions) return "Shipping restrictions apply";
    return "";
  },
  fulfillmentTileProps(state, getters) {
    return {
      isLoading: state.shipping.inlineLoading,
      selectedShipping: getters.computedSelectedShippingMethod,
      editorProps: getters.addressEditorProps,
      tileContent: getters.fulfillmentTileContent,
      isSizeSelected: getters.isSizeSelected,
      isColorSelected: getters.isColorSelected,
      sizeLabel: getters.sizeLabel,
      colorLabel: getters.colorLabel
    };
  },
  /**
   * getters.computedAddToCartButtonProps
   *
   * @param {Boolean} state.cartLoadState
   * @param {Number} state.quantity
   * @param {String} getters.appPropsMap.textStrings.membershipCost
   * @param {C9rProductDetailConversion} getters.c9rProductDetailConversion
   * @param {Boolean} getters.canAddToCart
   * @param {Number} getters.computedPrice.minPrice.value
   * @param {Boolean} getters.disableAddToCart
   * @param {Boolean} getters.includeMembershipInAddToCart
   * @param {Boolean} getters.isPreorder
   *
   * @returns {Object} props for BuyBoxAddToCart component
   */
  computedAddToCartButtonProps(state, getters) {
    const {
      cartLoadState,
      quantity
    } = state;
    const {
      c9rProductDetailConversion: {
        addToCart: c9rAddToCartConversion,
        preorder: c9rPreorderConversion
      },
      canAddToCart,
      disableAddToCart: isDisabled,
      includeMembershipInAddToCart,
      isPreorder
    } = getters;
    const dataCnstrcBtn = isPreorder ? c9rPreorderConversion : c9rAddToCartConversion;
    const {
      value
    } = getters.computedPrice.minPrice;
    const {
      membershipCost
    } = getters.appPropsMap.textStrings;
    const basePrice = includeMembershipInAddToCart ? value * quantity + parseInt(membershipCost, 10) : value * quantity;
    const price = canAddToCart ? basePrice.toFixed(2) : "";
    return {
      cartLoadState,
      dataCnstrcBtn,
      isDisabled,
      isPreorder,
      price
    };
  },
  /**
   * getters.disableAddToCart
   *
   * Logic to determine whether 'button is disabled'
   */
  disableAddToCart(state, getters) {
    return getters.isSkuSelected && !getters.canAddToCart;
  },
  /**
   * getters.showMemberOnlyAddToCart
   *
   * Logic to determine whether 'add membership to cart'
   * option appears for member-only products.
   * Source for both validation and display logic
   *
   * @param {Boolean} getters.unifiedCustomerData.isMember
   * @param {Boolean} getters.showNotifyMe
   * @param {Boolean} getters.computedIsMemberOnly
   * @param {Boolean} getters.hasMembershipInCart
   */
  showMemberOnlyAddToCart(state, getters) {
    return !getters.showNotifyMe && getters.computedIsMemberOnly && !getters.unifiedCustomerData.isMember && !getters.hasMembershipInCart;
  },
  /**
   * getters.membershipMessaging
   * Props for BuyBoxMembership component
   *
   * @param {Boolean} getters.unifiedCustomerData.isLoggedIn
   * @param {Boolean} getters.unifiedCustomerData.isMember
   * @param {String} getters.computedDividend.message
   * @param {Boolean} getters.computedDividend.show
   * @param {Boolean} getters.computedIsMemberOnly
   * @returns {Object} Props object for the display of the BuyBoxMembership component
   */
  membershipMessaging(state, getters) {
    var _a, _b, _c;
    const {
      isLoggedIn,
      isMember
    } = getters.unifiedCustomerData;
    const {
      message,
      showDividendMessage,
      dividendPercentage
    } = getters.computedDividend;
    const {
      mabcEarnPeriodToggle
    } = getters.appPropsMap;
    const {
      membershipATC
    } = getters.appPropsMap.triageToggles;
    const {
      membershipCost
    } = getters.appPropsMap.textStrings;
    const loggedInWithoutMembership = isLoggedIn && !isMember;
    const unknownMemberStatus = !isLoggedIn || loggedInWithoutMembership;
    const isMemberOnly = getters.computedIsMemberOnly;
    const showMemberOnlyCheckbox = getters.showMemberOnlyAddToCart;
    const showRewardsMessageCheckbox = showDividendMessage && !isMemberOnly && !isMember && membershipATC;
    const accountMembershipLink = ((_b = (_a = getters.appPropsMap) == null ? void 0 : _a.endpoints) == null ? void 0 : _b.accountMembershipLink) || "";
    const showMembershipMessageCheckbox = !showRewardsMessageCheckbox && !showMemberOnlyCheckbox && !getters.hasMembershipInCart && state.product.anyOversizeCharges;
    const showMABCOffPrice = !isMember && (mabcEarnPeriodToggle == null ? void 0 : mabcEarnPeriodToggle.enabled) && !isMABCExcludedItem((_c = state.product.primaryCategory) == null ? void 0 : _c.name) && !getters.hasMembershipInCart && !showDividendMessage && !state.product.anyOversizeCharges;
    const showAnyCheckbox = (showMemberOnlyCheckbox || showRewardsMessageCheckbox || showMembershipMessageCheckbox || showMABCOffPrice) && unknownMemberStatus;
    const showMembershipSection = (showDividendMessage || showAnyCheckbox) && !getters.shouldShowBillboardsMixedPrice && !getters.hideRewardsPlacements;
    return {
      accountMembershipLink,
      amount: message,
      error: state.buyBoxValidation.membership.hasError,
      includeMembership: state.includeMembership,
      isLoggedIn,
      isMember,
      isMemberOnly,
      loginPath: getters.computedLoginPath,
      membershipCost,
      dividendPercentage,
      showAnyCheckbox,
      showDividendMessage,
      showMABCOffPrice,
      showMemberOnlyCheckbox,
      showMembershipMessageCheckbox,
      showMembershipSection,
      showRewardsMessageCheckbox
    };
  },
  /**
   * props for Notify Me component
   *
   * @param {String} state.notifyMe.email
   * @param {Boolean} getters.isNotifiedSku
   * @param {String} state.notifyMe.errorMessage
   * @param {Boolean} state.buyBoxValidation.notifyMe.hasError
   * @returns {Object} props for Notify Me component
   */
  notifyMeProps(state, getters) {
    return {
      email: state.notifyMe.email,
      favoriteButtonProps: getters.favoriteButtonProps,
      isNotifiedSku: getters.isNotifiedSku,
      errorMessage: state.notifyMe.errorMessage,
      hasError: state.buyBoxValidation.notifyMe.hasError
    };
  },
  /**
   * getters.sizeChartData
   * Determines the data used in the 'Size chart' modal
   *
   * @param {Boolean} getters.isKidsBike
   * @param {Array} getters.kidsBikeSizeGuide
   * @param {Object} getters.computedSizeChart: main size chart data for all types of products
   * @returns {Object} data for size chart or size guide
   */
  sizeChartData(state, getters) {
    return getters.isKidsBike ? {
      ...getters.kidsBikeSizeGuide
    } : getters.computedSizeChart;
  },
  /**
   * getters.showSizeGuide
   *
   * Logic to determine when we should show the 'size guide'
   * When false, the 'size chart' is shown instead
   *
   * @param {Array} getters.sizeGuide
   * @param {Boolean} getters.hasBikeSizeGuide
   * @param {Boolean} getters.isKidsBike
   * @returns {Boolean}
   */
  showSizeGuide(state, getters) {
    var _a;
    const hasMultipleSizesToCompare = ((_a = getters.sizeGuide) == null ? void 0 : _a.length) > 1;
    const showAdultBikeSizeGuide = hasMultipleSizesToCompare && getters.hasBikeSizeGuide;
    return getters.isKidsBike ? true : showAdultBikeSizeGuide;
  },
  /**
   * getters.isNotifiedSku
   *
   * When a notify me request is successfully submitted the sku is added to the skusNotified array,
   * this is used to persist the success state if the user changes skus.
   *
   * @param {string} getters.computedSelectedSku.skuId
   * @param {array} state.notifyMe.skusNotified
   * @return {boolean} true if user has asked to be notified when selected sku is in stock
   */
  isNotifiedSku(state, getters) {
    const sku = getters.computedSelectedSku.skuId;
    return state.notifyMe.skusNotified.includes(sku);
  },
  /**
   * getters.showNotifyMe
   *
   * Logic to determine if the notify me form is shown instead of the buy box.
   *
   * @param {Boolean} getters.appPropsMap.triageToggles.notifyMe
   * @param {String} getters.computedSelectedSku.status
   * @param {Boolean} state.product.allDisplayableSkusAreBackorder
   * @return {boolean} true if the selected sku is or all sku are backordered
   */
  showNotifyMe(state, getters) {
    return getters.appPropsMap.triageToggles.notifyMe && (getters.computedSelectedSku.status === "BACKORDER" || state.product.allDisplayableSkusAreBackorder);
  },
  /**
   * @param {Boolean} state.customerAttributes.member
   * @param {Boolean} getters.unifiedCustomerData.isMember
   */
  showDoubleRewards(state, getters) {
    return getters.appPropsMap.launchToggles.showCobrandDoubleRewards && getters.unifiedCustomerData.isMember;
  },
  /**
   * Determines if the Cobrand card message is based on a user being
   * logged in and a member.
   *
   * @param {Boolean} state.customerAttributes.reiccholder
   * @param {Boolean} state.customerAttributes.member
   */
  showCobrand(state, getters) {
    const {
      isCardHolder,
      isMember
    } = getters.unifiedCustomerData;
    const showMessage = isMember && isCardHolder === false;
    const isKlarnaTest = getters.showKlarnaAboveATC || getters.showKlarnaBelowATC;
    return (showMessage || getters.showContextualizedEarn) && !isKlarnaTest;
  },
  /**
   * @param {string} getters.computedSelectedColor.code: color code for selected sku, e.g. "137603"
   * @param {number} getters.computedSelectedSku.skuId: currently selected sku # (10 digits)
   * @param {Array} state.product.flairBadges Array of flair badge objects
   * @returns {Object} Returns an object if there is flair badge data otherwise undefined
   */
  computedFlairBadge(state, getters) {
    var _a, _b, _c, _d, _e, _f;
    const {
      computedSelectedColor,
      computedSelectedSku
    } = getters;
    const flairBadge = (_b = (_a = state.product) == null ? void 0 : _a.flairBadges) == null ? void 0 : _b.find((badge) => {
      var _a2, _b2, _c2, _d2;
      return ((_b2 = (_a2 = badge == null ? void 0 : badge.colorIds) == null ? void 0 : _a2.toString()) == null ? void 0 : _b2.includes(computedSelectedColor == null ? void 0 : computedSelectedColor.code)) || ((_d2 = (_c2 = badge == null ? void 0 : badge.skuIds) == null ? void 0 : _c2.toString()) == null ? void 0 : _d2.includes(computedSelectedSku == null ? void 0 : computedSelectedSku.skuId));
    });
    const hasFlairForAllSellableSkus = ((_c = state.product) == null ? void 0 : _c.flairBadges) ? (_e = (_d = state.product) == null ? void 0 : _d.flairBadges[0]) == null ? void 0 : _e.productBadge : false;
    if (flairBadge) {
      return flairBadge;
    }
    if (hasFlairForAllSellableSkus) {
      return (_f = state.product) == null ? void 0 : _f.flairBadges[0];
    }
    return null;
  },
  /**
   * @param {Object} getters.contextualizedEarnMessage Contextualized earn message
   * @param {Object} getters.appPropsMap.textStrings A list of all available text strings for the PDP
   * @returns {Object} Returned object with all texts required for CoBrand component
   */
  cobrandMessage(state, getters) {
    const {
      contextualizedEarnMessage
    } = getters;
    const {
      textStrings,
      endpoints
    } = getters.appPropsMap;
    return {
      initialText: contextualizedEarnMessage || textStrings.initialPreApprovalCobrandText,
      ctaText: textStrings.preApprovalCobrandCtaText,
      finalText: textStrings.finalPreApprovalCobrandText,
      link: endpoints.cobrand
    };
  },
  /**
   * @param {Boolean} getters.appPropsMap.launchToggles.showContextualizedEarn Launch toggle for contextualized earn test MEM-2155, MEM-2291
   * @param {Array} getters.getEligibleTests A list of all eligible tests for the current PDP
   * @returns {Boolean} Show Contextualized Earn flag
   */
  showContextualizedEarn(state, getters) {
    return getters.appPropsMap.launchToggles.showContextualizedEarn || !!getters.activeAdobeExperiments.find((test) => test === getters.appPropsMap.abTestNames.contextualizedEarnVariant);
  },
  /**
   * @param {Boolean} showContextualizedEarn
   * @returns {String} ContextualizedEarn value calculated from price, show in test
   */
  // MEM-2155, MEM-2291
  contextualizedEarnMessage(state, getters) {
    var _a, _b;
    let fivePercent = null;
    const initialCobrandMsg = getters.appPropsMap.textStrings.initialPreApprovalCobrandText;
    const price = (_b = (_a = getters.computedPrice) == null ? void 0 : _a.minPrice) == null ? void 0 : _b.value;
    const totalPrice = price && state.quantity && price * state.quantity;
    if (initialCobrandMsg && totalPrice && getters.showContextualizedEarn) {
      fivePercent = `${initialCobrandMsg.replace("5%", `<b>$${(parseFloat(totalPrice, 10) * 0.05).toFixed(2)} (5%)</b>`)}`;
    }
    return fivePercent;
  },
  isLowInventorySku(state, getters) {
    if (!getters.isSkuSelected) return false;
    const {
      skuMap
    } = state.inventory;
    const {
      skuId
    } = getters.computedSelectedSku;
    if (skuMap < 1 || !skuId) return false;
    return !!skuMap.find((result) => result.sku === skuId && result.invLevel === "Low");
  },
  /**
   * getters.isColorSelected
   * Size / Color
   *
   * @param {string} getters.computedSelectedColor.code: selected color code or undefined
   * @return {boolean} true if a color is selected
   */
  isColorSelected(state, getters) {
    return !!getters.computedSelectedColor.code;
  },
  /**
   * getters.isSkuSelected
   * Size / Color
   *
   * @param {number} getters.computedSelectedSku.skuId: selected sku id # or undefined
   * @return {boolean} true if a sku is selected
   */
  isSkuSelected(state, getters) {
    return !!getters.computedSelectedSku.skuId;
  },
  /**
   * getters.isSizeSelected
   * Size / Color
   *
   * @param {string} getters.computedSelectedSize.label: selected size (e.g. 'XS') or undefined
   * @return {boolean} true if size is selected
   */
  isSizeSelected(state, getters) {
    return !!getters.computedSelectedSize;
  },
  isPriceSelected(state, getters) {
    const {
      isPriceByColor,
      isPriceBySize,
      isPriceBySizeAndColor
    } = state.product.mixedPriceOptions;
    if (isPriceByColor) {
      return getters.isColorSelected && getters.computedPrice.minPrice.value === getters.computedPrice.maxPrice.value;
    }
    if (isPriceBySize || isPriceBySizeAndColor) {
      return getters.isSizeSelected && getters.computedPrice.minPrice.value === getters.computedPrice.maxPrice.value;
    }
    return getters.computedPrice.minPrice.value === getters.computedPrice.maxPrice.value;
  },
  selectedSizeIsAvailable(state, getters) {
    var _a, _b, _c;
    const selectedPrice = getters.computedSelectedPriceValue;
    const selectedSize = getters.computedSelectedSize || state.tempSize;
    let isAvailable;
    if (selectedPrice) {
      isAvailable = getters.isColorSelected && selectedSize ? ((_b = (_a = state.product.optionsAvailableByPrice[selectedPrice]) == null ? void 0 : _a.sizes[selectedSize]) == null ? void 0 : _b.colors[getters.computedSelectedColor.code]) === true : true;
    } else {
      isAvailable = getters.isColorSelected && selectedSize ? ((_c = state.product.optionsAvailableWithoutPrice.colors[getters.computedSelectedColor.code]) == null ? void 0 : _c.sizes[selectedSize]) === true : true;
    }
    return isAvailable;
  },
  selectedColorIsAvailable(state, getters) {
    var _a, _b, _c;
    const selectedPrice = getters.computedSelectedPriceValue;
    const selectedColor = getters.computedSelectedColor.code || state.tempColor.code;
    const selectedSize = getters.computedSelectedSize;
    let isAvailable;
    if (selectedPrice) {
      isAvailable = getters.isSizeSelected && selectedColor ? ((_b = (_a = state.product.optionsAvailableByPrice[selectedPrice]) == null ? void 0 : _a.colors[selectedColor]) == null ? void 0 : _b.sizes[getters.computedSelectedSize]) === true : true;
    } else {
      isAvailable = getters.isSizeSelected && selectedColor ? ((_c = state.product.optionsAvailableWithoutPrice.colors[selectedColor]) == null ? void 0 : _c.sizes[selectedSize]) === true : true;
    }
    return isAvailable;
  },
  /* "S,M,L" sizes from `sizeChart` data */
  sizeGuideHeightRanges(state, getters) {
    var _a, _b;
    if (getters.hasBikeSizeGuide) {
      return (_b = (_a = state.product) == null ? void 0 : _a.sizeChart) == null ? void 0 : _b.rows.filter((row) => row.attribute === "Height Range").reduce((acc, row) => [...row.values], []);
    }
    return null;
  },
  /**
   * getters.sizeGuide
   * Retrieves the needed product.sizeChart data for the bike size calculator to consume
   *
   * @params from state:
   * @param {Object} product.sizeChart
   * @params from getters:
   * @param {Array<string>} sizeGuideHeightRanges: list of bike size height ranges
   * @returns {Array<object>}
   */
  sizeGuide(state, getters) {
    var _a;
    let sizeGuide = [];
    let hasIncompleteData = false;
    if (getters.hasBikeSizeGuide && ((_a = getters.sizeGuideHeightRanges) == null ? void 0 : _a.length) > 1) {
      const {
        sizeChart
      } = state.product;
      const parseHeight = (height) => {
        const results = height == null ? void 0 : height.match(/(?<feet>\d{1})'\s*(?<inches>\d{1,2})?"?/);
        if (results && results.length === 3) {
          const {
            feet,
            inches = 0
          } = (results == null ? void 0 : results.groups) || {};
          return {
            feet,
            inches
          };
        }
        return results;
      };
      const heightToInches = (height) => {
        const results = parseHeight(height);
        if (results) {
          const {
            feet,
            inches
          } = results;
          return feet * 12 + Number(inches);
        }
        return results;
      };
      try {
        for (const [index, size] of Object.entries(sizeChart.sizes)) {
          const [minHeight, maxHeight] = getters.sizeGuideHeightRanges[index].split("-");
          if (!minHeight || !maxHeight) {
            sizeGuide = [];
            break;
          }
          const minFeetAndInches = parseHeight(minHeight);
          const maxFeetAndInches = parseHeight(maxHeight);
          const minHeightInches = heightToInches(minHeight);
          const maxHeightInches = heightToInches(maxHeight);
          hasIncompleteData = !minFeetAndInches || !maxFeetAndInches || !minHeightInches || !maxHeightInches;
          if (hasIncompleteData) {
            if (typeof window !== "undefined") {
              logger.log("sizeGuide incomplete data", hasIncompleteData);
            }
            sizeGuide = [];
            break;
          }
          sizeGuide.push({
            size,
            minFeetAndInches,
            maxFeetAndInches,
            minHeightInches,
            maxHeightInches
          });
        }
      } catch (error) {
        if (typeof window !== "undefined") {
          logger.error("sizeGuide getter error", error);
        }
        sizeGuide = [];
      }
    }
    return sizeGuide;
  },
  kidsBikeSizeGuide() {
    return [{
      size: '12" wheels',
      inseam: '12"-17"',
      height: `2'6"-3'3"`,
      age: "2-4y",
      url: "?ir=category:kids-bikes&r=c;size:12+Inch+Wheel",
      linkName: "kids-bike-size-shop-all-12-inch",
      ageSrOnly: "Two to four years old",
      urlSrOnly: "12-inch"
    }, {
      size: '14" wheels',
      inseam: '16"-20"',
      height: `3'1"-3'8"`,
      age: "3-5y",
      url: "?ir=category:kids-bikes&r=c;size:14+Inch+Wheel",
      linkName: "kids-bike-size-shop-all-14-inch",
      ageSrOnly: "Three to five years old",
      urlSrOnly: "14-inch"
    }, {
      size: '16" wheels',
      inseam: '18"-22"',
      height: `3'3"-4'0"`,
      age: "5-8y",
      url: "?ir=category:kids-bikes&r=c;size:16+Inch+Wheel",
      linkName: "kids-bike-size-shop-all-16-inch",
      ageSrOnly: "Five to eight years old",
      urlSrOnly: "16-inch"
    }, {
      size: '20" wheels',
      inseam: '21"-25"',
      height: `3'7"-4'4"`,
      age: "6-10y",
      url: "?ir=category:kids-bikes&r=c;size:20+Inch+Wheel",
      linkName: "kids-bike-size-shop-all-20-inch",
      ageSrOnly: "Six to ten years old",
      urlSrOnly: "20-inch"
    }, {
      size: '24" wheels',
      inseam: '24"-28"',
      height: `4'2"-4'10"`,
      age: "8-12y",
      url: "?ir=category:kids-bikes&r=c;size:24+Inch+Wheel",
      linkName: "kids-bike-size-shop-all-24-inch",
      ageSrOnly: "Eight to twelve years old",
      urlSrOnly: "24-inch"
    }, {
      size: '26" wheels',
      inseam: '26"+',
      height: `4'8"+`,
      age: "10y+",
      url: "?ir=category:kids-bikes&r=c;size:26+Inch+Wheel",
      linkName: "kids-bike-size-shop-all-26-inch",
      ageSrOnly: "10 years old plus",
      urlSrOnly: "26-inch"
    }];
  },
  /* Map current kids bike size to kidsBikeSizeGuide `size` column */
  kidsBikeSizeTitle(state, getters) {
    var _a, _b, _c;
    if (!getters.isKidsBike) {
      return "";
    }
    const kidsBikeSize = (_a = state.product) == null ? void 0 : _a.sizes[0];
    const hasOneKidsBikeSize = ((_c = (_b = state.product) == null ? void 0 : _b.sizes) == null ? void 0 : _c.length) === 1;
    const kidsBikeProductSizeToTitle = {
      "12 IN": '12" wheels',
      "14 IN": '14" wheels',
      "16 IN": '16" wheels',
      "20 IN": '20" wheels',
      "24 IN": '24" wheels',
      "26 IN": '26" wheels'
    };
    const kidsProductTitle = kidsBikeProductSizeToTitle[kidsBikeSize];
    return hasOneKidsBikeSize && kidsProductTitle ? kidsProductTitle : "";
  },
  isHeightSelected(state, getters) {
    if (getters.hasBikeSizeGuide) {
      const {
        feet,
        inches
      } = state.sizeFinderSelectedSize;
      return Number.isInteger(feet) && Number.isInteger(inches);
    }
    return false;
  },
  isAutoSelectingBikeSizeAvailable(state, getters) {
    if (getters.hasBikeSizeGuide) {
      const {
        isPriceBySize,
        isPriceBySizeAndColor
      } = state.product.mixedPriceOptions;
      const {
        selectedSize
      } = getters.sizeSelectorProps;
      const hasOneSizeResult = state.sizeFinderResults.length === 1;
      const isSelectedSizeDifferent = selectedSize !== state.sizeFinderResults[0];
      return getters.isHeightSelected && !isPriceBySize && !isPriceBySizeAndColor && hasOneSizeResult && isSelectedSizeDifferent;
    }
    return false;
  },
  sizeFinderModalProps(state, getters) {
    return getters.hasBikeSizeGuide ? {
      productTitle: state.product.title,
      sizeGuide: getters.sizeGuide,
      sizeFinderSelectedSize: state.sizeFinderSelectedSize,
      sizeFinderResults: state.sizeFinderResults,
      isHeightSelected: getters.isHeightSelected,
      sizeFinderSeekerHeight: getters.computedSizeFinderSeekerHeight
    } : {};
  },
  kidsSizeFinderModalProps(state, getters) {
    return {
      size: getters.kidsBikeSizeTitle,
      kidsBikeSizeGuide: getters.kidsBikeSizeGuide
    };
  },
  isKidsBike(state) {
    var _a, _b;
    return (_b = (_a = state.product) == null ? void 0 : _a.breadcrumbs) == null ? void 0 : _b.some((breadcrumb) => {
      var _a2;
      return ((_a2 = breadcrumb == null ? void 0 : breadcrumb.item) == null ? void 0 : _a2.url) === "/c/kids-bikes";
    });
  },
  disclaimerModalData(state, getters) {
    const {
      price: {
        hideDisplayPrice
      },
      priceInfo: {
        showCompare
      }
    } = getters.buyBoxProps;
    const showImmediateMarkdowns = showCompare && !hideDisplayPrice;
    const hasOutletBadge = getters.outletBadgeIndex !== -1;
    let disclaimerName = "";
    if (hasOutletBadge && showImmediateMarkdowns) {
      disclaimerName = "Outlet";
    } else if (showImmediateMarkdowns) {
      disclaimerName = "Promotional and Clearance";
    }
    const modalData = {
      label: `${disclaimerName} Pricing`,
      labelIsTitle: true,
      ariaDescribedBy: "description",
      modalContent: "DisclaimerModal",
      modalProps: {
        disclaimerName
      },
      id: "disclaimer-modal"
    };
    return modalData;
  },
  /*-------------------------------------------------------------------
  application state updated with user interaction with fallback values for specific scenarios
  -------------------------------------------------------------------*/
  /**
   * getters.computedSelectedSize
   * Size / Color
   *
   * Calculates what size should be selected. If manually selected,
   * that value is returned. Preselects size if only one is available.
   * Prevents preselection for size/color/price dropdown
   *
   * @params from state:
   * @param {string} selectedSize: currently selected size e.g "SM", "POLARIZED"
   * @param {Array<string>} product.sizes: list of available sizes
   * @param {Object<Object>} product.byColor: color objects keyed by color code
   * @param {boolean} product.displayOptions.showSkuDropDown: whether the product
   *   has a sku dropdown
   * @params from getters:
   * @param {boolean} isColorSelected: true if a color is currently selected
   * @param {Obejct<string>} computedSelectedColor: currently selected color object
   * @returns {<string>}: selected size name, e.g "SM", "POLARIZED" or empty string
   */
  computedSelectedSize(state, getters) {
    var _a;
    const {
      isColorSelected,
      computedSelectedColor
    } = getters;
    const {
      byColor,
      displayOptions,
      sizes
    } = state.product;
    if (state.selectedSize) return state.selectedSize;
    if (displayOptions.showSkuDropDown && isColorSelected) {
      const sizesForColor = (_a = byColor == null ? void 0 : byColor[computedSelectedColor.code]) == null ? void 0 : _a.available;
      if ((sizesForColor == null ? void 0 : sizesForColor.length) === 1) return sizesForColor[0];
    }
    if (sizes.length === 1) {
      return sizes[0];
    }
    return "";
  },
  /**
     * getters.computedSelectedColor
     * Size / Color
     *
     * Calculate default selected color values for different scenarios,
     * or return user selected value
     *
     * @params from state:
     * @param {string} selectedSize.value: size e.g. 'XS'
     * @param {Object} selectedColor: color object for currently selected color
     * @param {boolean} product.displayOptions.showSkuDropdown: if true, product uses sku dropdown
     * @param {Array} colors: color objects
     * @params from getters:
     * @param {} computedSelectedSku.color:
     * @return {Object} color object with displayLabel
     */
  computedSelectedColor(state, getters) {
    if (state.selectedColor.displayLabel) return state.selectedColor;
    if (getters.availableColors.length === 1) return getters.availableColors[0];
    return {
      displayLabel: state.tempColor.displayLabel
    };
  },
  /**
     * getters.computedSelectedShippingMethod
     * @param {String} state.shipping.selectedShipping user selected shipping method, if provided
     * @returns {String} 'SHIP', or 'PICKUP'
     */
  computedSelectedShippingMethod(state, getters) {
    if (state.shipping.shippingMethod) return state.shipping.shippingMethod;
    if (getters.computedIsPickupOnly) return "PICKUP";
    return "SHIP";
  },
  /**
   * getters.computedPrice
   * Price display
   *
   * Transforms model data for both style and sku prices, see unit tests
   *   for examples of what these objects look like
   *
   * @param {object<*>} state.product.stylePrice: complex object with
   *   price data for the style,
   * @params from getters:
   * @param {boolean} isSkuSelected: is a sku currently selected
   * @param {Object<*>} computedSelectedSku.price: complex object with
   *   price data for the selected sku
   * @return {Object} price object for display.
   */
  computedPrice(state, getters) {
    var _a;
    const transformSkuPrice = (price) => ({
      minPrice: {
        ...price.price
      },
      maxPrice: {
        ...price.price
      },
      maxCompareAt: {
        ...price.compareAt
      },
      minCompareAt: {
        ...price.compareAt
      },
      hideDisplayPrice: price.hideDisplayPrice,
      offerType: price.price.offerType,
      savingsPercentage: price.savingsPercentage
    });
    if ((_a = state.selectedPrice) == null ? void 0 : _a.price) return transformSkuPrice(state.selectedPrice);
    if (getters.isSkuSelected) {
      return transformSkuPrice(getters.computedSelectedSku.price);
    }
    const {
      maxSavingsPercentage,
      minSavingsPercentage,
      ...stylePriceRest
    } = state.product.stylePrice;
    return state.product.stylePrice && {
      savingsPercentMax: maxSavingsPercentage,
      savingsPercentMin: minSavingsPercentage,
      ...stylePriceRest
    };
  },
  /**
   * getters.displayPrice
   * Display Price object (moved from BuyBoxPrice.vue)
   *
   * Moved due to business logic getting mixed with display logic in Vue component
   *
   * @returns {Object} Price display info
   */
  displayPrice(state, getters) {
    const formatPrice = (price) => price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const {
      maxCompareAt,
      minCompareAt,
      maxPrice,
      minPrice,
      savingsPercentage,
      savingsPercentMax,
      savingsPercentMin
    } = getters.computedPrice;
    const min = minPrice.value ? formatPrice(minPrice.value) : "";
    const max = maxPrice.value ? formatPrice(maxPrice.value) : "";
    let compare = {};
    if (minPrice.value && minCompareAt.value) {
      compare = {
        min: formatPrice(minCompareAt.value),
        max: formatPrice(maxCompareAt.value)
      };
    }
    return {
      min,
      max,
      compare,
      savingsPercentage,
      savingsPercentMax,
      savingsPercentMin
    };
  },
  /**
   * getters.priceInfo
   * Returns some of the business logic needed to display price info on the PDP
   *
   * @param {Object} getters.computedPrice
   * @returns {Object} Display logic for BuyBoxPrice
   */
  priceInfo(state, getters) {
    const {
      minCompareAt,
      maxPrice,
      minPrice,
      savingsPercentage,
      savingsPercentMax,
      savingsPercentMin,
      hideDisplayPrice
    } = getters.computedPrice;
    const styleOnSale = minPrice.sale && maxPrice.sale;
    const isAnyStyleOnSale = minPrice.sale || maxPrice.sale;
    const showCompare = styleOnSale && minPrice.value < minCompareAt.value && !!minCompareAt.value;
    const showRange = minPrice.value !== maxPrice.value;
    const showSaleRange = showRange && isAnyStyleOnSale;
    const showStylePriceSavingsPercent = showCompare && !!savingsPercentMin && !!savingsPercentMax;
    const hasSavingsPercents = !!savingsPercentage || !!savingsPercentMax;
    const showPercentOffSavings = !hideDisplayPrice && (hasSavingsPercents || showStylePriceSavingsPercent || showSaleRange);
    return {
      styleOnSale,
      isAnyStyleOnSale,
      showCompare,
      showRange,
      showSaleRange,
      showStylePriceSavingsPercent,
      showPercentOffSavings
    };
  },
  /**
   * numerical value of current price either selected or hovered over
   * - used to calculate mixed price availability
   *
   *
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  computedSelectedPriceValue(state, getters) {
    let selectedPrice;
    if (state.tempPrice.price) selectedPrice = state.tempPrice.price.value;
    if (getters.isPriceSelected) selectedPrice = getters.computedPrice.minPrice.value;
    return selectedPrice;
  },
  computedRecommendedSizesInches(state, getters) {
    const recommendedSizes = [];
    if (getters.hasBikeSizeGuide && getters.isHeightSelected) {
      const {
        feet,
        inches
      } = state.sizeFinderSelectedSize;
      const {
        sizeGuide
      } = getters;
      if (Number.isInteger(feet) && Number.isInteger(inches)) {
        const selectedHeightInches = feet * 12 + Number(inches);
        for (const row of sizeGuide) {
          if (row.minHeightInches <= selectedHeightInches && selectedHeightInches <= row.maxHeightInches) {
            recommendedSizes.push(row.size);
          }
        }
      }
    }
    return recommendedSizes;
  },
  computedSizeFinderSeekerHeight(state, getters) {
    let seekerHeight = 0;
    if (getters.hasBikeSizeGuide && getters.isHeightSelected) {
      const {
        feet,
        inches
      } = state.sizeFinderSelectedSize;
      const heightInInches = feet * 12 + Number(inches);
      seekerHeight = heightInInches;
    }
    return seekerHeight;
  },
  selectedPriceClearanceMessage(state, getters) {
    var _a, _b, _c, _d, _e;
    let message = "";
    const selectedPriceIsClearance = ((_c = (_b = (_a = getters.computedSelectedSku) == null ? void 0 : _a.price) == null ? void 0 : _b.price) == null ? void 0 : _c.clearance) === true && ((_e = (_d = state.selectedPrice) == null ? void 0 : _d.price) == null ? void 0 : _e.clearance) === true;
    const {
      areAllSkusClearance
    } = state.product.stylePrice;
    message = selectedPriceIsClearance && !areAllSkusClearance ? "Clearance" : "";
    return message;
  },
  /*-------------------------------------------------
  computed availability based on selected attributes
  -------------------------------------------------*/
  /**
   * getters.computedSinglePriceSizeGroups
   * @param {Array} state.product.sizes list of all available sizes for a style
   * @param {Boolean} getters.isColorSelected computed property
   * @param {Object} state.product.optionsAvailableWithoutPrice Object with size name as key
   * and available status as values
   * @param {Object} getters.computedSelectedColor
   * @returns {Array} list of sizes in display order with availability status.
   * If no color is selected, all sizes have availability set to true
   */
  computedSinglePriceSizeGroups(state, getters) {
    var _a, _b;
    let sizes;
    const soldOutSizesEnabled = (_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.enableSoldOutSizes;
    if (!getters.isColorSelected) {
      sizes = soldOutSizesEnabled ? state.product.sizesV2.map((size) => ({
        name: size,
        available: state.product.sizes.includes(size)
      })) : state.product.sizes.map((size) => ({
        name: size,
        available: true
      }));
    } else {
      const sizeObj = soldOutSizesEnabled ? state.product.sizesV2 : state.product.sizes;
      const optionsAvailableObj = soldOutSizesEnabled ? state.product.optionsAvailableWithoutPriceV2 : state.product.optionsAvailableWithoutPrice;
      sizes = sizeObj.map((size) => {
        var _a2;
        return {
          name: size,
          available: ((_a2 = optionsAvailableObj.colors[getters.computedSelectedColor.code]) == null ? void 0 : _a2.sizes[size]) === true
        };
      });
    }
    return [{
      sizes
    }];
  },
  /**
   * getters.computedSinglePriceColorGroups
   * Size / Color
   *
   * Colors to be displayed by the app for non mixed price color scenarios
   * with 'none' labeled items filtered out.
   *
   * @param {boolean} getters.isSizeSelected
   * @param {Array<Object>} getters.availableColors: color objects with displayLabels added
   * @param {Object} state.product.optionsAvailableWithoutPrice Object with size name as key
   * and available status as values
   * @return {Array<Object>} array of color objects with availability data and empty price data,
   * e.g [{ colors: [{ color: ColorDTO, available: Boolean }]]
   */
  computedSinglePriceColorGroups(state, getters) {
    let colors;
    const sourceColors = getters.availableColors;
    if (getters.isSizeSelected && state.product.mixedPriceOptions.isMixedPrice && getters.isPriceSelected) {
      colors = sourceColors.filter(({
        name
      }) => name.toLowerCase() !== "none").map((color) => {
        var _a;
        return {
          color,
          available: ((_a = state.product.optionsAvailableByPrice[getters.computedSelectedPriceValue].sizes[getters.computedSelectedSize]) == null ? void 0 : _a.colors[color.code]) === true
        };
      });
    } else if (getters.isSizeSelected && !state.product.mixedPriceOptions.isMixedPrice) {
      colors = sourceColors.filter(({
        name
      }) => name.toLowerCase() !== "none").map((color) => {
        var _a;
        return {
          color,
          available: ((_a = state.product.optionsAvailableWithoutPrice.sizes[getters.computedSelectedSize]) == null ? void 0 : _a.colors[color.code]) === true
        };
      });
    } else {
      colors = sourceColors.filter(({
        name
      }) => name.toLowerCase() !== "none").map((color) => ({
        color,
        available: true
      }));
    }
    return [{
      colors,
      priceData: {}
    }];
  },
  /**
   * getters.computedDropdownAvailableSizes
   * Size / Color
   * @param {boolean} state.product.displayOptions.showSkuDropDown: product uses sku dropdown
   * @param {Array} state.product.sizes
   * @param {Object} state.product.byColor availablility map keyed by color code
   * @param {Array<Object>} getters.skuDropdownLabels: data for sku dropdown (label, sku)
   * @param {Array<Object>} getters.isColorSelected
   * @return {Array<Object>} list of available display sizes. If size/color/price
   * dropdown is used, returns concatenated display labels.
   * Filters out 'none' size labels for all other products
   */
  computedDropdownAvailableSizes(state, getters) {
    if (state.product.displayOptions.showSkuDropDown) return getters.skuDropdownLabels;
    return getters.isColorSelected ? state.product.byColor[getters.computedSelectedColor.code].available.filter((size) => size.toLowerCase() !== "none") : state.product.sizes.filter((size) => size.toLowerCase() !== "none");
  },
  /**
   * getters.computedDropdownUnavailableSizes
   * Size / Color
   *
   * On products with too many sizes for the size button display,
   * only shows on products w/color selected
   *
   * @param {Object<Object>} state.product.byColor: map of skus by color
   * @param {boolean} state.product.displayOptions.showSkuDropDown
   * @params from getters:
   * @param {boolean} isColorSelected: is a color currently selected
   * @param {string} computedSelectedColor.code: currently selected color code
   * @returns {Array<Object>} array of unavailable sizes formatted for display.
   * For size/color/price dropdown styles, this data is not used.
   * For all other styles, filters out 'none' labeled sizes.
   */
  computedDropdownUnavailableSizes(state, getters) {
    var _a, _b;
    if (state.product.displayOptions.showSkuDropDown || !getters.isColorSelected) return [];
    const enableSoldOutSizes = (_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.enableSoldOutSizes;
    const byColorObj = enableSoldOutSizes ? state.product.byColorV2 : state.product.byColor;
    return byColorObj[getters.computedSelectedColor.code].unavailable.filter((size) => size.toLowerCase() !== "none");
  },
  /**
   * getters.computedDropdownUnavailableForAllSizes
   * Size / Color
   *
   * Computes which set of sizes are unavailable for all colors
   * of a given product
   *
   * @param {boolean} state.product.displayOptions.showSkuDropDown
   * @params from getters:
   * @param {boolean} isColorSelected: is a color currently selected
   * @param {string} appPropsMap.launchToggles.enableSoldOutSizes: boolean if
   * sold out size variation should be performed
   * @returns {Set<string>} sizes: the set of unavailable sizes for all options
   * For size/color/price dropdown styles, this data is not used.
   * For all other styles, filters out 'none' labeled sizes.
   */
  computedDropdownUnavailableForAllSizes(state, getters) {
    var _a, _b;
    let sizes = /* @__PURE__ */ new Set();
    if (state.product.displayOptions.showSkuDropDown || !((_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.enableSoldOutSizes)) return sizes;
    Object.keys(state.product.byColorV2).forEach((colourCode, i) => {
      const unavailableSizes = state.product.byColorV2[colourCode].unavailable.filter((size) => size.toLowerCase() !== "none");
      if (i === 0) sizes = /* @__PURE__ */ new Set([...unavailableSizes]);
      const newSet = /* @__PURE__ */ new Set([...unavailableSizes]);
      sizes = sizes.intersection(newSet);
    });
    return sizes;
  },
  /**
   * getters.sizeDisplayGroups
   *
   * ordered list of sizes arranged by price group in descending order
   * includes availability data
   * meant to produce UI - order derived from controller data
   *
   * @param {Array} state.product.sizes List of sizes ordered by controller
   * @param {Object} getters.computedSelectedColor
   * @param {Object} getters.mixedPriceOptions computed values representing mixed price scenarios
   * @param {} state.product.optionsAvailableByPrice, List map of availability relationships
   * between price, size and color
   * @returns {Array<Object>} for mixed price size or size/color scenarios,
   * returns an array of objects of price data for corresponding groups of sizes, e.g.:
   * [{ priceData: { PriceDTO }, sizes: [{ available: Boolean, name: String }] }]
   *
   * for single-price scenarios, returns getters.computedSinglePriceSizeGroups -
   * an array with one value corresponding to the same contract as above
   */
  sizeDisplayGroups(state, getters) {
    var _a, _b;
    const soldOutSizesEnabled = (_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.enableSoldOutSizes;
    if (state.product.mixedPriceOptions.isPriceBySize || state.product.mixedPriceOptions.isPriceBySizeAndColor) {
      return state.product.availablePrices.map((priceData) => {
        const priceValue = priceData.price.value;
        const sizesForPrice = [];
        const altReturnStatement = (size, price) => {
          var _a2;
          return soldOutSizesEnabled ? (_a2 = state.product.optionsAvailableByPriceV2[price].sizes[size]) == null ? void 0 : _a2.available : true;
        };
        const optionsAvailable = soldOutSizesEnabled ? state.product.optionsAvailableByPriceV2 : state.product.optionsAvailableByPrice;
        const sizes = soldOutSizesEnabled ? state.product.sizesV2 : state.product.sizes;
        const equalityToObey = (size) => {
          var _a2, _b2, _c;
          return soldOutSizesEnabled ? ((_a2 = optionsAvailable[priceValue]) == null ? void 0 : _a2.sizes[size]) !== void 0 : (_c = (_b2 = optionsAvailable[priceValue]) == null ? void 0 : _b2.sizes[size]) == null ? void 0 : _c.available;
        };
        sizes.forEach((size) => {
          var _a2, _b2;
          if (equalityToObey(size)) {
            const colorCode = getters.computedSelectedColor.code;
            const availableForSelectedColor = getters.isColorSelected ? ((_b2 = (_a2 = optionsAvailable[priceValue]) == null ? void 0 : _a2.sizes[size]) == null ? void 0 : _b2.colors[colorCode]) === true : altReturnStatement(size, priceValue);
            const sizeData = {
              name: size,
              available: availableForSelectedColor
            };
            sizesForPrice.push(sizeData);
          }
        });
        return {
          priceData,
          sizes: sizesForPrice
        };
      });
    }
    return getters.computedSinglePriceSizeGroups;
  },
  /**
   * getters.colorDisplayGroups
   * ordered list of color groups associated by prices
   * meant to produce UI
   *
   * @param {Object} state.product.colors all colors for a style
   * @param {Boolean} getters.mixedPriceOptions.isPriceByColor
   * @param {Object} state.product.optionsAvailableByPrice availability map of all
   * possible size/price/color combinations
   * @param {String} getters.computedSelectedSize
   * @param {Boolean} getters.isSizeSelected computed value
   * @returns {Array} list of objects that contain price data and a corresponding
   * array of colors available for that size, with availability for a selected size nested within
   * e.g. [{ priceData: { PriceDTO || null }, colors: [{ available: Boolean, color: ColorDTO } }]]
   */
  colorDisplayGroups(state, getters) {
    if (state.product.mixedPriceOptions.isPriceByColor) {
      return state.product.availablePrices.map((priceObj) => {
        const price = priceObj.price.value;
        const colorsForPrice = [];
        const {
          colors
        } = state.product;
        colors.forEach((color) => {
          var _a, _b, _c, _d;
          if ((_b = (_a = state.product.optionsAvailableByPrice[price]) == null ? void 0 : _a.colors[color.code]) == null ? void 0 : _b.available) {
            const selectedSize = getters.computedSelectedSize;
            const availableForSelectedSize = getters.isSizeSelected ? ((_d = (_c = state.product.optionsAvailableByPrice[price]) == null ? void 0 : _c.colors[color.code]) == null ? void 0 : _d.sizes[selectedSize]) === true : true;
            const colorData = {
              color,
              available: availableForSelectedSize
            };
            colorsForPrice.push(colorData);
          }
        });
        return {
          priceData: priceObj,
          colors: colorsForPrice
        };
      });
    }
    return getters.computedSinglePriceColorGroups;
  },
  /*------------------------------------------------------
  remapping controller data with default fallback content
  -------------------------------------------------------*/
  /**
   * getters.colorLabel
   * Size / Color
   *
   * Label for the color swatches, if provided. Defaults to 'Color'
   *
   * @param {?string} state.product.displayOptions.colorLabel:
   *   label for the color swatches, or ''
   * @return {string} examples: 'Color' (default), 'Flavor'
   */
  colorLabel(state) {
    return state.product.displayOptions.colorLabel || "Color";
  },
  /**
   * getters.computedBuyBoxAlertMessage
   * Determines which promo/early access message to display
   * in the BuyBox.
   * @returns {Object} message and boolean for alert rendering
   */
  computedBuyBoxAlertMessage(state, getters) {
    let message = getters.computedEarlyAccessMessage;
    if (message) {
      return {
        message,
        isEAMessage: true
      };
    }
    message = getters.computedPriceOfferMessage;
    return message ? {
      message
    } : null;
  },
  /**
  * getters.computedPriceOfferMessage
  * promo messages currently tied to the price area by the buyBox
  * e.g. sale, clearance, fullPrice, and "all" messages
  *
  * @param {Object} state.messages.promo.priceOffer: messages keyed by type (e.g. "sale"),
  *   with values { message: 'string', contentUri: 'string' }
  * @param {Object} getters.appPropsMap.showPriceOfferMessages: app prop toggles for
  *   each message type (true = show message)
  * @param {Object} getter.computedPrice.OfferType: the current price type as it relates
  *   to which type of promo should show (sale, clearance, fullPrice, all)
  */
  computedPriceOfferMessage(state, getters) {
    const {
      showPriceOfferMessages
    } = getters.appPropsMap;
    const {
      priceOffer
    } = state.messages.promo;
    const {
      offerType
    } = getters.computedPrice;
    const {
      areAllSkusClearance
    } = state.product.stylePrice;
    const cleanedMessages = {};
    const showMessage = (msg) => showPriceOfferMessages[msg] === true;
    if (!priceOffer || !offerType || !showPriceOfferMessages || offerType === "none") return "";
    if (!areAllSkusClearance && offerType === "clearance") return "";
    Object.keys(priceOffer).forEach((msg) => {
      cleanedMessages[msg] = priceOffer[msg] && showMessage(msg) ? priceOffer[msg].message : "";
    });
    return cleanedMessages.all || cleanedMessages[offerType] || "";
  },
  /**
   * getters.computedEarlyAccessMessage
   * @param {string} state.product.badges[0].message: product badge object message
   * @returns {string} early access message for Just for Members product
   */
  computedEarlyAccessMessage(state) {
    var _a, _b;
    const msg = (_b = (_a = state.product) == null ? void 0 : _a.badges[0]) == null ? void 0 : _b.message;
    return msg || "";
  },
  /**
   * getters.sizeLabel
   * Size / Color
   *
   * Alternate dropdown labels like 'Flavor', etc
   *
   * @param {?string} state.product.displayOptions.sizeLabel: label for size dropdown
   * @return {string} label for size dropdown, if provided. Defaults to 'Size'
   */
  sizeLabel(state) {
    return state.product.displayOptions.sizeLabel || "Size";
  },
  /**
   * getters.computedDividend
   * @param {String} state.product.displayOptions.dividendEstimatedSavingsText:
   * will be either '10%' or a formatted dollar amount
   * @param {String} state.product.displayOptions.dividendEstimatedSavingsPercentageText:
   * will be '10%' or null
   * @param {Boolean} state.product.displayOptions.showDividendMessage:
   * controller data on whether to show or hide dividend message
   */
  computedDividend(state) {
    return {
      message: state.product.displayOptions.dividendEstimatedSavingsText,
      dividendPercentage: state.product.displayOptions.dividendEstimatedSavingsPercentageText,
      showDividendMessage: state.product.displayOptions.showDividendMessage
    };
  },
  klarnaPrice(state, getters) {
    var _a, _b;
    const dollarsToPennies = (dollars) => parseInt(Math.round(dollars * 100), 10);
    const finalKlarnaPrice = ((_a = getters.computedAddToCartButtonProps) == null ? void 0 : _a.price) !== "" ? dollarsToPennies((_b = getters.computedAddToCartButtonProps) == null ? void 0 : _b.price) : 1;
    return Number.isInteger(finalKlarnaPrice) ? finalKlarnaPrice : void 0;
  },
  /*-------------------------------------------------------------------
  static relationship maps (could be deprecated in favor of controller)
  -------------------------------------------------------------------*/
  /**
   * getters.computedPricePermutations
   * count out all possible size/price and color/price combinations
   * used to determine what display scenario should be displayed
   *
   * @param {*} state not used
   * @param {Array} state.product.optionsAvailableByPrice  list of price/size/color combinations.
   * builds/flattens an array of all available options (color and size) for each possible sku price
   * @returns {object} e.g. for a style with 5 price/color combinations
   * and 10 price/size combinations
   * {
   *  sizes: 10,
   *  colors: 5
   * }
   */
  computedPricePermutations(state) {
    const collections = Object.values(state.product.optionsAvailableByPrice).reduce((acc, group) => {
      const availableColors = Object.values(group.colors).filter((color) => color.available);
      const availableSizes = Object.values(group.sizes).filter((size) => size.available);
      acc.colors = [...acc.colors, ...availableColors];
      acc.sizes = [...acc.sizes, ...availableSizes];
      return acc;
    }, {
      colors: [],
      sizes: []
    });
    return {
      colors: collections.colors.length,
      sizes: collections.sizes.length
    };
  },
  orderedNewColorData(state, getters) {
    var _a;
    if (!((_a = getters.availableColors) == null ? void 0 : _a.length)) {
      return [];
    }
    const unorderedColors = [...getters.availableColors];
    const firstColor = unorderedColors.shift();
    const colorGroups = unorderedColors.reduce((acc, color) => {
      var _a2;
      if ((_a2 = color.badges) == null ? void 0 : _a2.includes("New")) {
        acc.new.push(color);
      } else {
        acc.old.push(color);
      }
      return acc;
    }, {
      new: [],
      old: []
    });
    return [firstColor, ...colorGroups.new, ...colorGroups.old];
  },
  favoriteButtonProps(state, getters) {
    var _a;
    return {
      dataCnstrcBtn: (_a = getters == null ? void 0 : getters.c9rProductDetailConversion) == null ? void 0 : _a.addToWishlist,
      isFavorite: getters.isSkuInWishlist
    };
  },
  /**
   * getters.showEstimatedRewards
   * @param {Boolean} isRewardsGte30Item: item is dividend-eligible && sell price >= 20
   * @param {Boolean} allowRewardsTag: feature toggle for rewards tag
   * @returns {Boolean}
   */
  showEstimatedRewards(state, getters) {
    var _a, _b;
    if (getters.hideRewardsPlacements) return false;
    return !!(((_b = (_a = getters.appPropsMap) == null ? void 0 : _a.triageToggles) == null ? void 0 : _b.allowRewardsTag) && state.product.displayOptions.showDividendMessage && state.product.stylePrice.minPrice.value >= 20);
  },
  /**
   * getters.estimatedRewardsText
   * @param {String} state.product.displayOptions.dividendEstimatedSavingsText:
   * will be either '10%' or a formatted dollar amount
   * @returns {String}
   */
  estimatedRewardsText(state) {
    var _a, _b;
    const value = (_b = (_a = state == null ? void 0 : state.product) == null ? void 0 : _a.displayOptions) == null ? void 0 : _b.dividendEstimatedSavingsText;
    return `Members get an est. ${value} in rewards`;
  }
};
export {
  buyBoxGetters as default
};
//# sourceMappingURL=buyBoxGetters.mjs.map
